<template>
    <div class="card">
        <DataTable
            :value="permissions"
            :lazy="true"
            :paginator="true"
            :rows="10"
            ref="dt"
            dataKey="id"
            :totalRecords="totalRecords"
            :loading="loading"
            @page="onPage($event)"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[5, 10, 20, 50, 100]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <template #empty> No Permissions Available. </template>
            <Column field="id" header="SN" ref="id"> </Column>
            <Column field="code" header="CODE" ref="code"> </Column>
            <Column field="description" header="DESCRIPTION" ref="description"> </Column>
            <Column field="active" header="ACTIVE" ref="active">
                <template #body="slotProps">
                    <span class="p-column-title">ACTIVE</span>
                    <Tag :value="slotProps.data.active == 1 ? 'True' : 'False'" :severity="slotProps.data.active == 1 ? 'success' : 'danger'" rounded="true"></Tag>
                </template>
            </Column>
            <Column field="created_at" header="CREATED AT" ref="created_at" />
        </DataTable>
    </div>
</template>

<script>
import PermissionService from '@/services/permission-service';
import { formatDate } from '@/helpers/date-formatter';

export default {
    name: 'PermissionListTable',
    data() {
        return {
            loading: false,
            totalRecords: 0,
            permissions: null,
            lazyParams: {},
        };
    },
    permissionService: null,
    created() {
        this.permissionService = new PermissionService();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: null,
            sortOrder: null,
            page: null,
        };

        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.loading = true;
            setTimeout(async () => {
                const bodyParams = {
                    page_size: this.lazyParams?.rows ?? 10,
                    page: this.lazyParams?.page ?? 1,
                    paginate: true,
                    product: 2, // PHA
                };
                await this.permissionService.getPermissions(bodyParams).then((response) => {
                    this.permissions = response.data.data?.map((permission) => {
                        return {
                            ...permission,
                            created_at: formatDate(permission.created_at),
                        };
                    });
                    this.totalRecords = response.data.total;
                    this.loading = false;
                });
            }, Math.random() * 1000 + 250);
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
    },
};
</script>
